export default "__VITE_ASSET__CJsJe7_Y__"